import { Observable, throwError } from 'rxjs';
import { HttpInterceptor } from '@angular/common/http/src/interceptor';
import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { API_URL } from './api';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BoSpinnerService } from '../../shared';

@Injectable()
export class IntercepterService implements HttpInterceptor {
    private wCredentials: boolean = true;
    private branchId: string;
    constructor(
        @Inject(API_URL) private apiUrl: string,
        private router: Router,
        private _spinner: BoSpinnerService,
    ) {
        
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({
            url: this.prepareUrl(req.url),
            withCredentials: this.wCredentials
        });
        this.wCredentials = true;
        return next.handle(req)
            .pipe(catchError((err) => {
                this._spinner.hide();
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        // redirect to login page
                        this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname } });
                    }
                    return throwError(err);
                }
            }));
    }

    private isAbsoluteUrl(url: string): boolean {
        const absolutePattern = /^https?:\/\//i;
        return absolutePattern.test(url);
    }

    private prepareUrl(url: string): string {
        if (this.branchId) { url = this.addQueryUrl(url, `branchNavigation=${this.branchId}`); }
        if (url.indexOf('/api/') > -1) {
            if (this.isAbsoluteUrl(url)) {
                this.wCredentials = false;
            } else {
                url = this.apiUrl + url;
            }
        }
        return url.replace(/([^:]\/)\/+/g, '$1');
    }

    private addQueryUrl(url: string, query: string): string {
        const paths = url.split('?');
        return `${paths[0]}?${paths[1] ? `${paths[1]}&` : ''}${query}`;
    }
}

